module.exports = __webpack_public_path__ + "static/media/configure_icon.b7c289a0.png";